import React, { useEffect, useState } from "react";
import { Backdrop, Button, LogoLoader, Modal, TableAdv } from "../../../../../components";
import { mapTableRows } from "../../../../../utils";
import { fetchAllSubmissions } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { usePagination } from "../../../../../hooks";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatWords2 } from "../../../../../utils/stringUtils";
import ApplicantsDetailsDrawer from "../../../Applicants/Applicant/Modal/ApplicantsDetailsDrawer";
import { convertFromUTC } from "../../../../../utils/dateUtils";

const Submission = ({ submissions }) => {
  const dispatch = useDispatch();
  const [submissionRows, setSubmissionRows] = useState([]);
  const [candidateTotalSubmisions, setCandidateTotalsubmissions] = useState([]);
  const [activeCandidate, setActiveCandidate] = useState();
  const [candidateTotalSubmisionsCount, setCandidateTotalsubmissionsCount] = useState([]);

  const { value } = useSelector((state) => state?.totalCount);
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => { }
  );
  const { page: canPage, limit: canLimit, setPage: canSetPage, handleLimitChange: canHandleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => { }
  );

  const totalCount = value?.sub?.data || 0;
  const [loading, setLoading] = useState(true);
  const submissionIds = (submissions || [])
    .map((sub) => (typeof sub === "object" ? sub?.uiid : sub))
    .filter(Boolean);
  const [detailsDrawer, setDetailsDrawer] = useState(false);
  const [selectedApplicantId, setSelectedApplicantId] = useState(null);
  const [isModelopen, setIsModelOpen] = useState(false);

  const colSubmission = [
    {
      key: "sNo",
      label: "S.No",
      columnMenu: false,
      render: (row) => <div className="flex items-center">
        <p>{row?.sNo}</p>
        <Button
          type="icon"
          color="black"
          icon={"visibility"}
          onClick={() => {
            setSelectedApplicantId(row.candidateUiid);
            setDetailsDrawer(true); // then open drawer
          }}
          variant="text"
          size="sm"
        />
      </div>,
    },
    {
      key: "name",
      label: "Name",
      columnMenu: false,
      render: (row) => (
        <Link
          to={`/ats/applicants/applicant-details`}
          state={{ applicantId: row.candidateUiid, source: "/ats/jobs/job-details?job-details=submission" }}
          className="text-info-400 flex items-center gap-.5"
        >
          <span className="mx-2">{formatWords2(row?.name)}</span>
        </Link>
      ),
    },
    {
      key: "email",
      label: "Email ID",
      columnMenu: false
    },
    {
      key: "phone",
      label: "Phone number",
      columnMenu: false
    },
    {
      key: "jobTitle",
      label: "Job Title",
      columnMenu: false
    },
    {
      key: "experience",
      label: "Experience (In years)",
      columnMenu: false
    },
    {
      key: "workAuthorization",
      label: "Work Authorization",
      columnMenu: false
    },
    {
      key: "location",
      label: "Location",
      columnMenu: false
    },
    {
      key: "noOfSubmissions",
      label: "No. of Submissions",
      columnMenu: false,
      render: (row) => (
        <p className="text-info-400 cursor-pointer" onClick={() => {
          setIsModelOpen(true)
          setActiveCandidate(row);
          setCandidateTotalsubmissionsCount(row?.noOfSubmissions)
        }}>{row?.noOfSubmissions}</p>
      ),
    },
  ];

  const candidateTotalSubmissonsCols = [
    {
      key: "sNo",
      label: "S.No",
      columnMenu: false,
    },
    {
      key: "applicantName",
      label: "Applicant Name",
      columnMenu: false,
    },
    {
      key: "jobCode",
      label: "Job Code",
      columnMenu: false
    },
    {
      key: "jobTitle",
      label: "Job Title",
      columnMenu: false
    },
    {
      key: "account",
      label: "Account",
      columnMenu: false
    },
    {
      key: "submittedOn",
      label: "Submitted On",
      width: 170,
      columnMenu: false
    },
    {
      key: "submittedBy",
      label: "Submitted By",
      columnMenu: false
    },
    {
      key: "applicantCreatedBy",
      label: "Applicant Created By",
      columnMenu: false
    },
    {
      key: "applicantCreatedOn",
      label: "Applicant Created On",
      columnMenu: false,
    },
  ];

  const rowSubmission = Array.from({ length: 5 }, (_, i) => ({
    id: i + 100,
    sNo: i + 1,
    name: "Jack Raison",
    email: "jackrai@gmail.com",
    phone: "+(1)7984592873",
    jobTitle: "Frontend Developer",
    experience: "3",
    workAuthorization: "USA",
    location: "Dallas",
  }));

  const mappedRowSubmission = mapTableRows(rowSubmission, colSubmission);
  const fetchSubmissions = async () => {
    // if (!submissions?.length) return;
    try {
      setLoading(true);
      const res = await fetchAllSubmissions({
        coll: "Submission",
        pg: page,
        lim: limit,
        ref: "JobPosting Candidate",
        fil: { uiid: { type: "IN", value: submissionIds }, "statusHistory.status": { type: "ARRAY_LAST_TWO_FIELDS_EQ", value: 3 } },
        // fil: { uiid: { type: "IN", value: submissions },"statusHistory.status": {  type: "ARRAY_LAST_TWO_FIELDS_EQ", value: 1 }  },
        ret: "uiid candidateId jobPostId",
        extret: "uiid firstName",
        incl: ["jobInfo.workAuth jobInfo.location", "uiid firstName lastName email mobile salaryInfo.payRate jobTitle exp workAuth"],
        sort: { addedOn: -1 },
      });
      const data = res?.data?.data || [];
      const candidateIds = data.map(c => c?.candidateId?.uiid);

      const eachCandidateSubmission = await fetchAllSubmissions({
        coll: "Submission",
        useAggregate: true,
        fil: { uiid: { type: "AG_CANDIDATE_SUBMISSIONS", value: candidateIds } },
      });
      const eachCandidateSubmissionData = eachCandidateSubmission?.data?.data || [];
      const submissionCountMap = eachCandidateSubmissionData.reduce((acc, item) => {
        acc[item.candidateId] = item.totalSubmissions || 0;
        return acc;
      }, {});


      const formattedRows = data.map((item, index) => ({
        id: item.uiid,
        sNo: index + 1,
        candidateUiid: item?.candidateId?.uiid,
        name: `${item?.candidateId?.firstName || ""} ${item?.candidateId?.lastName || ""
          }`.trim(),
        // email: item?.candidateId?.email?.primary || item?.candidateId?.email || "N/A",
        email:
          typeof item?.candidateId?.email === "string"
            ? item?.candidateId?.email
            : item?.candidateId?.email?.primary?.email || "N/A",
        phone: item.candidateId?.mobile?.primary
          ? `${item.candidateId?.mobile.primary.code} ${item.candidateId.mobile.primary.number}`
          : "N/A",
        jobTitle: formatWords2(item?.candidateId?.jobTitle || "N/A"),
        experience: item?.candidateId?.exp ? `${item?.candidateId?.exp.year || 0}y ${item?.candidateId?.exp.mon || 0}m`
          : "N/A",
        workAuthorization: item?.candidateId?.workAuth ? formatWords2(item?.candidateId?.workAuth) : "N/A",
        location: item?.jobPostId?.jobInfo?.location
          ? `${item?.jobPostId?.jobInfo?.location.city || ""}, ${item?.jobPostId?.jobInfo?.location.state || ""}`
          : "N/A",
        noOfSubmissions: submissionCountMap[item?.candidateId?.uiid] || 0,
      }));

      setSubmissionRows(mapTableRows(formattedRows, colSubmission));
    } catch (err) {
      console.error("Error fetching submissions:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCandidateTotalSubmissions = async () => {
    if (!activeCandidate || !candidateTotalSubmisionsCount) return;

    try {
      setLoading(true);
      const res = await fetchAllSubmissions({
        coll: "Submission",
        pg: canPage,
        lim: canLimit,
        useAggregate: true,
        fil: { uiid: { type: "AG_CANDIDATE_TOTALSUBMISSIONS", value: activeCandidate?.candidateUiid || null }, },
      });
      const data = res?.data?.data || [];
      const candidateSubmissionsFormattedRows = data.map((item, index) => ({
        sNo: index + 1,
        applicantName: formatWords2((item?.candidate?.firstName || "N/A")) + " " + formatWords2((item?.candidate?.lastName || "N/A")),
        jobCode: item?.jobPost?.jobCode || "N/A",
        jobTitle: formatWords2(item?.jobPost?.title || "N/A"),
        account: formatWords2(item?.company?.name || "N/A"),
        submittedOn: convertFromUTC(item?.addedOn || "N/A"),
        submittedBy: formatWords2(item?.submissionAddedBy?.name || "N/A"),
        applicantCreatedBy: formatWords2(item?.candidateCreatedBy?.name || "N/A"),
        applicantCreatedOn: convertFromUTC(item?.candidateCreatedBy?.addedOn || "N/A"),
      }));
      setCandidateTotalsubmissions(mapTableRows(candidateSubmissionsFormattedRows, candidateTotalSubmissonsCols));
    } catch (err) {
      console.error("Error fetching submissions:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "submissions",
        coll: "Submission",
        tname: "sub",
        app: "ats",
        filters: { uiid: { type: "IN", value: submissionIds }, "statusHistory.status": { type: "ARRAY_LAST_TWO_FIELDS_EQ", value: 3 } }
      })
    );
    fetchSubmissions();
  }, [submissions, dispatch, limit, page]);

  useEffect(() => {
    fetchCandidateTotalSubmissions();
  }, [activeCandidate, canLimit, canPage])

  // if (loading) {
  //   return (
  //     <div className="flex items-center justify-center">
  //       <LogoLoader />
  //     </div>
  //   );
  // }

  return (
    <div className="flex flex-col gap-5 my-5 flex-1 overflow-hidden">
      <div className="flex-1 overflow-hidden flex gap-4 p-0.5">
        <div className="flex-1 overflow-hidden shadow-tableset">
          <TableAdv
            //showCheckbox
            columns={colSubmission}
            // rows={mappedRowSubmission}
            rows={submissionRows}
            serverPagination={true}
            totalCount={totalCount}
            page={page}
            limit={limit}
            onPaginationChange={setPage}
            onLimitChange={handleLimitChange}
            tdClassName="!py-3"
            toolbarRight={{
              search: true,
              add: [
                {
                  component: (
                    <div className="flex items-center gap-2">
                      <Button title="Bulk Mail" size="sm" />
                    </div>
                  ),
                },
              ],
            }}
          />
        </div>
      </div>
      <ApplicantsDetailsDrawer
        isOpen={detailsDrawer}
        onClose={() => setDetailsDrawer(false)}
        applicantId={selectedApplicantId}
        source={"Submissions"}
        page={page}
        limit={limit}
      />
      <Modal
        isOpen={isModelopen}
        onClose={() => {
          setIsModelOpen(false)
          setActiveCandidate();
          setCandidateTotalsubmissionsCount()
        }}
        title={`${formatWords2(activeCandidate?.name)}'s Total Submissions`}
        titleColor={'primary'}
        width="max-w-7xl"
      >
        <TableAdv
          rows={candidateTotalSubmisions}
          columns={candidateTotalSubmissonsCols}
          serverPagination={true}
          totalCount={candidateTotalSubmisionsCount}
          page={canPage}
          limit={canLimit}
          onPaginationChange={canSetPage}
          onLimitChange={canHandleLimitChange}
        />
      </Modal>
      <Backdrop isOpen={loading} zIndex={54}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default Submission;
